import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CurrentMedications = ({ medications, onRequestRefill, onViewAll }) => {
  const getRefillStatusColor = (daysRemaining) => {
    if (daysRemaining <= 7) return 'bg-destructive/10 text-destructive';
    if (daysRemaining <= 14) return 'bg-warning/10 text-warning';
    return 'bg-success/10 text-success';
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg">
            <Icon name="Pill" size={20} color="var(--color-accent)" />
          </div>
          <div>
            <h2 className="text-lg md:text-xl font-semibold text-foreground">Current Prescriptions</h2>
            <p className="text-xs md:text-sm text-muted-foreground">Active dental prescriptions</p>
          </div>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onViewAll}
        >
          <span className="hidden md:inline">View All</span>
          <span className="md:hidden">All</span>
        </Button>
      </div>
      <div className="space-y-3">
        {medications?.length === 0 ? (
          <div className="text-center py-8 md:py-12">
            <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full mx-auto mb-4">
              <Icon name="PillOff" size={32} className="text-muted-foreground" />
            </div>
            <p className="text-sm md:text-base text-muted-foreground">No active prescriptions</p>
          </div>
        ) : (
          medications?.map((medication) => (
            <div
              key={medication?.id}
              className="bg-background rounded-lg border border-border p-4"
            >
              <div className="flex flex-col md:flex-row md:items-center gap-3">
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">
                    {medication?.name}
                  </h3>
                  <p className="text-xs md:text-sm text-muted-foreground mb-2">
                    {medication?.dosage} • {medication?.frequency}
                  </p>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className={`text-xs font-medium px-2 py-1 rounded ${getRefillStatusColor(medication?.daysRemaining)}`}>
                      {medication?.daysRemaining} days remaining
                    </span>
                    <span className="text-xs text-muted-foreground">
                      Prescribed by {medication?.prescribedBy}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  {medication?.refillsRemaining > 0 ? (
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="RefreshCw"
                      iconPosition="left"
                      onClick={() => onRequestRefill(medication)}
                      className="flex-1 md:flex-none"
                    >
                      Request Refill ({medication?.refillsRemaining})
                    </Button>
                  ) : (
                    <span className="text-xs text-destructive font-medium">No refills remaining</span>
                  )}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default CurrentMedications;